const prefix = 'FLIGHT_DETAILS';
export const createActionTypes = (resource) => ({
    LOAD: `${prefix}/${resource}/LOAD'`,
    LOADING: `${prefix}/${resource}/LOADING'`,
    LOADED: `${prefix}/${resource}/LOADED'`,
});
export const loadControlTowerExperienceActionTypes = createActionTypes('LOAD_CONTROL_TOWER_EXPERIENCE');
export const loadFlightControlActionTypes = createActionTypes('LOAD_FLIGHT_CONTROL');
export const flightDetailsActionTypes = {
    SET_CURRENT_FLIGHT: `${prefix}/SET_CURRENT_FLIGHT`,
    RESET_STATE: `${prefix}/RESET_STATE`,
};
export const loadFlightControl = (flightId, workspaceId, managementGroup) => {
    return {
        type: loadFlightControlActionTypes.LOAD,
        payload: {
            flightId,
            workspaceId,
            managementGroup,
        },
    };
};
export const loadingFlightControl = (payload) => {
    return {
        type: loadFlightControlActionTypes.LOADING,
        payload: { flightId: payload.flightId },
    };
};
export const loadedFlightControl = (flightId, flightControl) => {
    return {
        type: loadFlightControlActionTypes.LOADED,
        payload: {
            flightId,
            flightControl,
        },
    };
};
export const loadControlTowerExperience = (flightId, workspaceId, managementGroup) => {
    return {
        type: loadControlTowerExperienceActionTypes.LOAD,
        payload: {
            flightId,
            workspaceId,
            managementGroup,
        },
    };
};
export const loadingControlTowerExperience = (payload) => {
    return {
        type: loadControlTowerExperienceActionTypes.LOADING,
        payload: { flightId: payload.flightId },
    };
};
export const loadedControlTowerExperience = (payload, controlTowerExperience) => {
    return {
        type: loadControlTowerExperienceActionTypes.LOADED,
        payload: {
            flightId: payload.flightId,
            workspaceId: payload.workspaceId,
            managementGroup: payload.managementGroup,
            controlTowerExperience,
        },
    };
};
export const resetState = (flightId) => {
    return {
        type: flightDetailsActionTypes.RESET_STATE,
        payload: { flightId },
    };
};

//# sourceMappingURL=FlightDetails.ducks.js.map
